import Router from "./Router";
import "css/App.css";
import React, { useState, useEffect, useRef } from "react";
import useLocalStorage from "hooks/useLocalStorage";
import Global from "library/Global";
import Lib from "library";
import { useNavigate, useLocation, Navigate } from "react-router-dom";
import { Alert, Nav, Header, Loading, Auth, Toast, LayerBottom, Button } from "components";
import { v4 as uuid } from "uuid";
import Native from "library/native";
import LayerStates from "states/LayerStates";
import { useRecoilState, useSetRecoilState  } from "recoil";
import {
  certFromState,
  certTxIdState,
  detailResultDataState,
  resultDataState,
  reqCdState,
  getSncnApiSelector,
} from "views/data/states";
import { safeAreaInsetState, userState, systemState, popupState, checkMyDataLinkState, myDataLinkResultUrlState, myDataLinkBottomLayerState } from "states";

import { pushDataState } from "views/setting/states";
import { eDocNaverTxIdSelector } from "views/edoc/apply/states";
import { raonCertRequestResponse } from "views/edoc/states";

const AppContext = React.createContext();
const AuthContext = React.createContext();

window.Lib = Lib;
window.Native = Native;

const App = () => {
  //#region Variables
  const App = useRef();
  const Core = useRef();
  const navigate = useNavigate();
  const location = useLocation();
  const main = useRef();
  //#endregion

  //#region States
  const [didRun, setDidRun] = useLocalStorage("didRun", false); // 최초 실행 여부
  const [user, setUser] = useRecoilState(userState); // 유저
  const [system, setSystem] = useRecoilState(systemState);
  const [isLogin, setIsLogin] = useState(); // 로긴 여부
  const [showNav, setShowNav] = useState(true); // Nav 표시 여부
  const [showHeader, setShowHeader] = useState(true); // Header 표시 여부
  const [shield, setShield] = useState(false); // shield 표시 여부
  const [headerClass, setHeaderClass] = useState(); // HeaderClass
  const [headerLeft, setHeaderLeft] = useState(); // Header 좌측
  const [headerRight, setHeaderRight] = useState(); // Header 우측
  const [title, setTitle] = useState(Global.orgName); // 타이틀
  const [alerts, setAlerts] = useState([]); // 경고들
  const [showLoading, setShowLoading] = useState(false); // 로딩 보이기
  // const [pushData, setPushData] = useState() //
  const [toastText, setToastText] = useState("");
  const [showToast, setShowToast] = useState(false);
  const [layers, setLayers] = useRecoilState(LayerStates);
  const [backConfirm, setBackConfirm] = useState(false);

  const [certTxId, setCertTxId] = useRecoilState(certTxIdState);
  const [certFrom, setCertFrom] = useRecoilState(certFromState);
  const setResultData = useSetRecoilState(resultDataState);
  const setDetailResultData = useSetRecoilState(detailResultDataState);
  const setSafeAreaInsets = useSetRecoilState(safeAreaInsetState);
  const [eDocNaverTxId, setEDocNaverTxId] = useRecoilState(eDocNaverTxIdSelector)

  const [raonCertRequestRes,setRaonCertRequestResponse] = useRecoilState(raonCertRequestResponse)
  const [raonCertCheck,setRaonCertCheck] = useState(false)
  const setReqCd = useSetRecoilState(reqCdState);

  const [pushData, setPushData] = useRecoilState(pushDataState); // 푸쉬 데이터
  const params = new URLSearchParams(location.search);

  const [scrollY, setScrollY] = useState(0); // 스크롤 Y

  const [sncnApis, setSncnApis] = useRecoilState(getSncnApiSelector); // 서비스 채널별 인가된 API 정보

  // DB 이중화 서버 점검 공지 state
  const [popup, setPopup] = useRecoilState(popupState);

  // 마데 연동 완료 state
  const [checkMyDataLink, setCheckMyDataLink] = useRecoilState(checkMyDataLinkState)
  const setMyDataLinkResultUrl = useSetRecoilState(myDataLinkResultUrlState)
  const [myDataLinkBottomLayer, setMyDataLinkBottomLayer] = useRecoilState(myDataLinkBottomLayerState)
  
  const dataCertificate = (id) => {
    navigate("/dataCertificate", {
      state: {
        id: id,
      },
    });
  };
  // 백그라운드 진입 후 포그라운드시만 체크되도록 처리
  const onForegroundApp = ()=>{
    if(raonCertRequestRes && raonCertCheck){
      setRaonCertCheck(false)
      setEDocNaverTxId(raonCertRequestRes.txId)
    }
  }
  const onBackgroundApp = ()=>{
    setRaonCertCheck(true)
  }
  const onWakeApp = (scheme) => {
    // 사설인증(네이버)
    console.log(scheme);
    if (scheme) {
      const method = scheme.replace(/moneey:\/\/|\?.*/g, "");
      if (method === "dataCertificate") {
        const params = new URLSearchParams(scheme.match(/\?.*/)[0]);
        const certificateId = params.get("id");
        window[method](certificateId);
      } else if(method === "raonCert"){
        // raonCert통해 전달된 스킴으로 실행되는 케이스
        if(raonCertRequestRes){
          setEDocNaverTxId(raonCertRequestRes.txId)
        }
      } else {
        // 기존 네이버 사설 인증 - txId가 존재시만 처리
        const params = new URLSearchParams(scheme.match(/\?.*/)[0])
        const txId = params.get("txId")
        if (txId) {
          setEDocNaverTxId(txId)
        }

      }
    }
    
    if (typeof eDocNaverTxId !== "undefined") {

      Global.hideLoading();
    }
    // DONE: 깨어났을때 세션 체크, 타이머 리셋
    Global.refrechSession();
    console.log("%cwoke up!", "color: red");

    if (typeof certTxId === "undefined") return;
    Global.showLoading();
    const params = { certTxId: certTxId };
    if (certFrom === "modify") {
      params.clsfcCode = "CHNG";
    } else if (certFrom === "extend") {
      params.clsfcCode = "EXPND";
    }
    Lib.post({
      url: "/api/data/link/intgr/auth/private/sign/result/v2",
      
      onSuccess: (data) => {
        setCertTxId();
        const currentPath = window.location.pathname;
				let url
				if (certFrom === "detail" || certFrom === "modify") {
					setDetailResultData(data)
					url = "/data/detailLinkResult"
				} else if (certFrom === "extend") {
					setResultData(data)
					url = "/mydata/manageResult"
				} else {
					setResultData(data)
					url = "/data/dataLinkResult"
				}
				if(currentPath === "/data/DataGifLoading"){
					setCheckMyDataLink(undefined) // 마데 연동 state 초기화
					navigate(url)
				}else {
					setMyDataLinkResultUrl(url) // 마데 연동 완료 확인
					setCheckMyDataLink(true) // 마데 연동 완료 확인
				}
      },
      onFail: (res) => {
          setCheckMyDataLink(undefined) // 마데 연동 state 초기화
          Global.alert(`${res.data.msg??"연동 처리시 오류가 발생했습니다.<br />잠시 후 다시 진행하시기 바랍니다."}`,()=>navigate(-1))

      },
      data: params,
      onError:(res) =>{
				setCheckMyDataLink(undefined) // 마데 연동 state 초기화
				Global.alert(`${res.data.msg??"연동 처리시 오류가 발생했습니다.<br />잠시 후 다시 진행하시기 바랍니다."}`,()=>navigate(-1))

			}
    });
    navigate("/data/DataGifLoading")

    // let url;
    // if (
    //   certFrom === "detail" ||
    //   certFrom === "extend" ||
    //   certFrom === "modify"
    // ) {
    //   // 상세, 연장, 변경
    //   url = "/api/data/lnkup/intgr/auth/rslt/step2/naver";
    // } else {
    //   url = "/api/data/lnkup/intgr/auth/rslt/step1/naver";
    // }
    // Global.showLoading();
    // const params = { cert_tx_id: certTxId };
    // if (certFrom === "modify") {
    //   params.clsfc_code = "CHNG";
    // } else if (certFrom === "extend") {
    //   params.clsfc_code = "EXPND";
    // }

    // Lib.post({
    //   url: url,
    //   data: params,
    //   onSuccess: (data) => {
    //     setCertTxId();
    //     if (certFrom === "detail" || certFrom === "modify") {
    //       // 상세
    //       setDetailResultData(data);
    //       navigate("/data/detailLinkResult");
    //     } else if (certFrom === "modify") {
    //       setResultData(data);
    //       navigate("/mydata/manageResult");
    //     } else if (certFrom === "extend") {
    //       // 전송요구 연장
    //       setResultData(data);
    //       navigate("/mydata/manageResult");
    //     } else {
    //       setResultData(data);
    //       navigate("/data/dataLinkResult");
    //     }
    //   },
    //   onFail: (data, error) => {
    //     // 팝업 미노출 : onFail 추가 진행 후에 아무런 코드가 없으면 팝업이 나타나지 않음.
    //     // console.log('onFail',`${data} / ${error.number} / ${error.message}`)

    //     // loading 하이드되는 부분은 공통으로 최종적으로 처리가 되도록 되어있습니다.
    //     // Global.hideLoading();
    //   },
    // });
  };

  const goIndCertResult = (reqCd) => {
    // 개별인증 (웹)
    setReqCd(reqCd);
    navigate("/data/detailLinkResult");
  };

  const showIndCertError = (params) => {
    const decoded = decodeURIComponent(unescape(params));
    console.error(decoded);
    /* const error = params.get("error")
        const error_desc = params.get("error_description")
        console.error(error)
        console.log(error_desc) */
    Global.alert(`error: ${decoded}`);
  };

  // 씽크풀에서 콜하는 경우 네이티브에서 callback
  const goThinkPayCallback = (params) => {
    const decoded = JSON.parse(params);

    // if(decoded.type ==="useGuide") {

    // 	navigate("/thinkpool/thinkInfo", {
    // 		state:
    // 		{
    // 			fromGb: "thinkpool",
    // 			backUrl: decoded.back_url, // 다시 씽크풀 페이지로 돌아갈 수 있는 url
    // 			purchasedUrl: decoded.purchased_url // 결재 성공 후 다시 씽크풀 페이지로 돌알갈 수 있는 url
    // 		}
    // 	})
    // }

    if (decoded.type === "purchase") {
      Lib.post("/api/inner/thinkpool/payInfo", (data) => {
        if (data && data.payYn === "Y") {
          navigate("/thinkpool/thinkPayAfter", {
            state: {
              fromGb: "thinkpool",
              backUrl: decoded.back_url, // 다시 씽크풀 페이지로 돌아갈 수 있는 url
              purchasedUrl: decoded.purchased_url, // 결재 성공 후 다시 씽크풀 페이지로 돌알갈 수 있는 url
            },
          });
        } else {
          navigate("/thinkpool/thinkPayBefore", {
            state: {
              fromGb: "thinkpool",
              backUrl: decoded.back_url, // 다시 씽크풀 페이지로 돌아갈 수 있는 url
              purchasedUrl: decoded.purchased_url, // 결재 성공 후 다시 씽크풀 페이지로 돌알갈 수 있는 url
            },
          });
        }
      });
    }

    // if(decoded.type ==="payAfter") {

    // 	navigate("/thinkpool/thinkPayAfter", {
    // 		state:
    // 		{
    // 			fromGb: "thinkpool",
    // 			backUrl: decoded.back_url, // 다시 씽크풀 페이지로 돌아갈 수 있는 url
    // 			purchasedUrl: decoded.purchased_url // 결재 성공 후 다시 씽크풀 페이지로 돌알갈 수 있는 url
    // 		}
    // 	})
    // }
  };

  // 씽크풀에서 콜하는 경우 네이티브에서 callback (마이데이터로 이동)
  const goDataLink = () => {
    //Global.alert("goDataLink params" + params);
    navigate("/data");
  };

  const appCall = (search) => {
    const params = new URLSearchParams(search);
    const os = Lib.getUserAgent();
    console.log(params);
    console.log(os);
    Global.alert(`appCall: ${decodeURI(search)}`);
  };

  const onRecvPush = (param) => {
    // Native에서 Push Click Event시 호출하는 function
    console.log("%cIN onRecvPush.", "color: blue; font-weight: bold");
    const json = decodeURIComponent(JSON.stringify(param));
    const str = json.replace(/\\/g, "");
    const str2 = str.slice(0, -1);
    const json2 = JSON.parse(str2.slice(1));
    console.log(
      "%conRecvPush Data : " + json,
      "color: blue; font-weight: bold"
    );

    if (json2.dvsnCd === "WEB") {
      // 웹 이동인 경우 native 호출
      Native.execute("AppManager", "openScheme", undefined, { url: json2.url });
    } else {
      console.log("224번 setPushData");
      setPushData(json2);

      // if (isLogin && json2.url) {

      if (json2.url) {
        const urlArr = json2.url.split("/");

        if (urlArr[1] !== "layer") {
          // 레이어가 아닌 경우,
          navigate(json2.url);
        } else {
          // 레이어인 경우, Home 에서 처리
          // navigate("/home");

          let urlParams = "push=" + urlArr[2];

          if (json2.no !== "") {
            urlParams = urlParams + "&no=" + json2.no;
          }

          // window.location.href="/home?"+urlParams;

          <Navigate to={"/home?" + urlParams} replace />;
          // window.location.replace="/home?"+urlParams;

          console.log(
            "%cGlobal.pushNav() navigate 이후 테스트",
            "color: blue; font-weight: bold"
          );
        }
      }
    }
  };

  Global.pushNav = (state) => {
    console.log(
      "%cGlobal.pushNav() state : " + JSON.stringify(state),
      "color: blue; font-weight: bold"
    );

    if (isLogin && pushData !== null && pushData.url) {
      // 로그인 상태일 때
      console.log(
        "%cGloval.pushNav() 로그인 상태일 때",
        "color: blue; font-widht: bold"
      );
      const urlArr = pushData.url.split("/");
      // 구글 애널리틱스 테스트 코드
      // if (urlArr[1] === "analytics") {
      //     // 사용자 ID 설정
      //     Native.execute("Analytics", "setUserID", result => { console.log("setUserID result = " + result) }, {userId: window.localStorage.getItem("mbId")});

      //     // 사용자 속성 설정
      //     Native.execute("Analytics", "setUserProperty", result => { console.log("setUserProperty result = " + result) }, {property: {userTcomCd: user.tcomCd, gender: user.gendr}});
      // }

      if (urlArr[1] !== "layer") {
        // 레이어가 아닌 경우,
        navigate(pushData.url);
      } else {
        // 레이어인 경우, Home 에서 처리
        navigate("/home");
        // navigate("/home", { replace: true });
        console.log(
          "%cGlobal.pushNav() navigate 이후 테스트",
          "color: blue; font-weight: bold"
        );
      }
    } else if (state?.push) {
      // Layer 이동이기 때문에 로그인 후 다시 왔을 때,
      // 푸쉬에서 레이어 이동인 경우,
      console.log(
        "%cGloval.pushNav() 로그인 후 레이어 이동일 때",
        "color: blue; font-widht: bold"
      );
      let push = {
        url: "/layer/" + state?.push,
        no: "",
      };

      if (state?.no) {
        push = {
          ...push,
          no: state?.no,
        };
      }
      console.log("296번 setPushData");
      setPushData(push);
      navigate(location.state?.from ?? "/home", { replace: true });
    } else {
      // window.history.replaceState(null, null, location.state?.from ?? "/home");
      navigate(location.state?.from ?? "/home", { replace: true });
    }
  };

  const onBackPress = () => {
    // const a = document.querySelector("nav .active"); // onBackPress 수정중
    const url = window.location.pathname;
    console.log("onBackPress !! window.location.pathname : ", url);
    console.log("onBackPRess !! Layer 띄워져있는 개수 : ", layers.length);
    const mainPages = ["/home", "/mydata", "/recommend"]; // 메인 페이지들 (3개)
    const resultPages = ["dataLinkResult", "detailLinkResult", "manageResult", "extendLinkResult"]; // 결과 페이지들 - 뒤로가기시 이전 홈으로
    const resultLoadingPages = ["dataGifLoading"]; // 결과 로딩 페이지들 - 뒤로가기 막아져야함.
    const pathNameList = url.split("/");
    const pathName = pathNameList[pathNameList.length - 1];
    if (mainPages.includes(url) && layers.length === 0) {
      // 앱 종료 팝업 띄울 때

      if (backConfirm) return;
      appClose();
    } else if (layers.length > 0) {
      // 레이어 닫을 때
      console.log("닫기전 layers :", layers);

      // if (layers.length === 1) {
      //     if (url !== "/recommend/grant") {
      //         // 정부지원금 결과조회
      //         document.querySelector("nav > a[href='"+url+"']").setAttribute('class', 'active');
      //     } else if (url.includes('/recommend/grant')) {
      //         Global.goBack();
      //     } else {
      //         document.querySelector("nav > a[href='/recommend']").setAttribute('class', 'active');
      //     }
      // }

      layers.map((fn) => {
        console.log("레이어 닫을 떄");
        console.log(fn);
      });

      const fn = layers[layers.length - 1];
      fn();
      console.log(fn);
      const newLayers = layers.filter(
        (item, index) => index < layers.length - 1
      );
      setLayers(newLayers);
    }else if(resultPages.includes(pathName)){
      // 마데 연동 결과 화면 백키 핸들링.
      if(pathNameList.length > 1 ){
        // 이전홈화면 이동
        navigate(`/${pathNameList[0]}`)
      }else{
        // 메인화면 이동
        navigate('/')
      }
    }else if(resultLoadingPages.includes(pathName)){
      // 마데 로딩화면
      return
    } else if (location.state?.from) {
      navigate(location.state?.from, { replace: true });
    } else {
      if (url == "/edocCertificate/edocCertiNaver" && location.state?.eltsgnReqstMetaInfoHashcd && location.state?.reqstXmlMetadataString) {
        navigate('/edocCertificate/applyPage',{replace:true})
      } else {

        Global.goBack();
      }

      // //console.log('url : ' + url)
      // if (typeof url === 'string') {
      //     // 은행 (bank)
      //     // 카드 (card)
      //     // 보험 (insurance)
      //     // 증권 (stock)
      //     // 신용 (credit)
      //     // 전자금융 (efinance)
      //     // 통신 (communication)
      //     // 개인IRP (irp)

      //     // 왜 있는지 몰라서 일단 주석
      //     // let param = {state: { new: "N" }};
      //     // if (url.toLowerCase().indexOf('compare') > -1 || url.toLowerCase().indexOf('predict') > -1) {
      //     //     if (url.indexOf('/mydata/bank') > -1) {
      //     //         navigate('/mydata/bankAccount', param);
      //     //     } else if (url.indexOf('/mydata/card') > -1) {
      //     //         navigate('/mydata/card', param);
      //     //     } else if (url.indexOf('/mydata/insurance') > -1) {
      //     //         navigate('/mydata/insurance', param);
      //     //     } else if (url.indexOf('/mydata/stock') > -1) {
      //     //         navigate('/mydata/stock', param);
      //     //     } else if (url.indexOf('/mydata/credit') > -1) {
      //     //         navigate('/mydata/creditMain', param);
      //     //     } else if (url.indexOf('/mydata/efinance') > -1) {
      //     //         navigate('/mydata/efinancePayment', param);
      //     //     } else if (url.indexOf('/mydata/communication') > -1) {
      //     //         navigate('/mydata/communication', param);
      //     //     } else if (url.indexOf('/mydata/irp') > -1) {
      //     //         navigate('/mydata/irpBank', param);
      //     //     } else {
      //     //         navigate('/mydata');
      //     //     }
      //     // } else if (url === '/mydata/creditCard' || url === '/mydata/creditLoan' || url === '/mydata/creditOverdue' || url === '/mydata/creditGuarantee') {
      //     //     navigate('/mydata/creditMain', param);
      //     // }
      //     // 왜 있는지 몰라서 일단 주석

      //     // else if (url === '/mydata/bankAccount' || url === '/mydata/bankLoan' || url === '/mydata/bankInvest'
      //     //         || url === '/mydata/card' || url === '/mydata/cardLoan' || url === '/mydata/cardPrepay'
      //     //         || url === '/mydata/insurance' || url === '/mydata/insuranceLoan'
      //     //         || url === '/mydata/stock'
      //     //         || url === '/mydata/creditMain'
      //     //         || url === '/mydata/efinancePayment' || url === '/mydata/efinancePay'
      //     //         || url === '/mydata/communication'
      //     //         || url === '/mydata/irpBank' || url === '/mydata/irpInsurance' || url === '/mydata/irpStock') {
      //     //         navigate('/mydata');
      //     // }
      //     //  else {
      //     //     Global.goBack();
      //     // }
      // } else {
      //     Global.goBack();
      // }
    }
  };

  const appClose = () => {
    setBackConfirm(true);

    Global.showAlert({
      msg: "앱을 종료하시겠습니까?",
      ok: "확인",
      cancel: "취소",
      confirm: true,
      onOk: () => Lib.nativeCall("AppManager", "appClose"),
      onCancel: () => setBackConfirm(false),
    });
  };

  Global.closeAllLayers = (callback) => {
    layers.forEach((fn) => {
      fn(false);
    });
    setLayers([]);
    callback && setTimeout(callback, 500);
  };

  //login
  const login = (module, callback) => {
    console.log("%cApp.js > login", "color: blue; font-weight: bold");
    // login API 호출
    const mbId = window.localStorage.getItem("mbId");
    if (!mbId) {
      console.log("%cmbID NOT FOUND", "color: blue; font-weight: bold");
      // window.localStorage.removeItem("didRun")
      setDidRun(false);
      navigate("/");
      return false;
    }
    Global.showLoading();
    const info = module.get_sessionInfo();
    const loginProcess = (deviceInfo) => {
      console.log(
        "%cApp.js > login > loginProcess",
        "color: blue; font-weight: bold"
      );
      const logData = {
        mbId: mbId,
        secId: info.sessionId,
        secToken: info.secToken,
        secInput: info.input,
        pushToken: deviceInfo.pushToken,
        appVersion: deviceInfo.appVersion,
        model: deviceInfo.model,
        os: deviceInfo.os,
        osVersion: deviceInfo.osVersion,
      };

      console.log("Device 정보 확인");
      console.log(logData);

      // WEB 테스트용
      // if (Global.test) {
      //   let mbId = window.localStorage.getItem("mbId");
      //   if (!mbId) mbId = "M_oVhAwe0dda8L8LP5wf";
      //   logData.mbId = mbId;
      //   logData.pw = "112233";
      // }

      Lib.post({
        url: `/api/mb/login`,
        onSuccess: async (data) => {
          // // 구글 애널리틱스 테스트 (사용자 ID 설정)
          // Native.execute("Analytics", "setUserID", result => { console.log("setUserID result = " + result) }, {userId: data.mbId});

          // // 구글 애널리틱스 테스트 (사용자 속성 설정)
          // Native.execute("Analytics", "setUserProperty", result => { console.log("setUserProperty result = " + result) }, {property: {model: data.model, propertyTest: "propertyTest"}});

          // 로그인 성공, accessToken 없을거나, undefined 일 때 재판매모델 로그인 API 호출

          // if (
          //   !window.localStorage.getItem("accessToken") ||
          //   window.localStorage.getItem("accessToken") === "undefined"
          // ) {
          await Lib.myPost({
            url: `/api/auth/login/v1?grant_type=username`,
            data: {
              ch_user_id: mbId,
              gender: data.gendr === "F" ? 2 : "1",
              style: "style",
              user_nm: data.mbNm,
            },
            onSuccess: (data) => {
              // TODO 코드 공통화 처리 되면 수정사항 발생
              // 로그인(토큰발급) 성공시 accessToken, refreshToken localStorage 저장
              window.localStorage.setItem("accessToken", data.access_token);
              window.localStorage.setItem("refreshToken", data.refresh_token);
            },
            onComplete: () => {
              Global.hideLoading();
            },
          });
          // }

          setUser(data);
          setIsLogin(true);
          window.localStorage.setItem(
            "useBio",
            data.bioAuthUseYn === "Y" ? "true" : "false"
          );
          if (callback) {
            console.log(
              "%cApp.js > login > loginProcess > success > callback",
              "color: blue; font-weight: bold"
            );
            console.log(callback);
            callback();
            // App.pushNav();
          } else {
            navigate("/");
          }
        },
        onFail: (res) => {
          console.log(res.code, res.msg);
          let url;
          module.refresh();
          if (res.code === "E104") {
            // "사용자 정보를 찾을 수 없습니다."
            window.localStorage.removeItem("mbId");
            window.localStorage.removeItem("didRun");
            window.localStorage.removeItem("useBio");
            url = false;
          } else if (res.code === "E002") {
            // 비번 5회 이상 틀림
            url = "/resetPassword";
          }
          Global.alert(`${res.code}: ${res.msg}`, () => {
            if (url) {
              navigate(url);
            } else {
              window.location.reload();
            }
          });
        },
        onError: ( res ) => {
          if (!res) {
            Global.alert("응답이 없습니다.");
            return;
          }
          console.log(res.data.code, res.data.msg);
          let msg;
          if (res.data.msg) {
            msg = `${res.data.code}: ${res.data.msg}`;
          } else {
            msg = "알수 없는 오류가 발생했습니다.<br />다시 시도해 주세요.";
          }
          Global.alert(msg);
          module.refresh();
        },
        onComplete: (res) => {
          Global.hideLoading();
        },
        // DONE: pushToken 추가
        data: logData,
      });
    };

    if (false) {
    } else {
      Global.deviceInfo((deviceInfo) => {
        loginProcess(deviceInfo);
      });
    }
  };

  // logout
  const logout = (callback) => {
    // logout API 호출
    Lib.post(`/api/mb/login/logout`, (data) => {
      setIsLogin(false);
      delete App.device;
      Global.closeAllLayers();
      if (callback) {
        callback();
      } else {
        navigate("/");
      }
    });
  };

  const sendSessionCheck = (cb) => {
    if (!isLogin) return;
    Lib.get(
      "/api/mb/login/chck",
      (data) => {
        setUser(data);
        setIsLogin(true);
        Global.timer = setSessionTimeout();
        cb && cb(data);
      },
      () => {
        logout();
      }
    );
  };

  const setSessionTimeout = () => {
    if (Global.timer) clearTimeout(Global.timer);
    return setTimeout(() => {
      clearTimeout(Global.timer);
      Global.showAlert({
        msg: "장시간 활동이 없어 자동으로 로그아웃됩니다.",
        sub: "계속 이용하시려면 로그인을 연장해주세요.",
        timer: 60, // 초단위
        confirm: true,
        onShow: () => {
          console.log("timeout.");
          clearTimeout(Global.timer);
        },
        onOk: () => {
          clearTimeout(Global.timer);
          sendSessionCheck(() => {
            Global.showAlert("연장되었습니다.");
          });
        },
        onCancel: () => {
          clearTimeout(Global.timer);
          logout();
        },
        onTimer: (alert) => {
          clearTimeout(Global.timer);
          Global.hideAlert(alert.id);
          Global.showAlert("로그아웃합니다.", () => {
            logout();
          });
        },
        ok: "로그인 연장하기",
        cancel: "로그아웃하기",
      });
    }, 1000 * 60 * 9); // 분단위
  };
  Global.sessionTimerReset = function () {
    if (isLogin) {
      Global.timer = setSessionTimeout();
    }
  };

  const getSafeAreaInsets = () => {
    // 안드로이드에서는 Native에서 처리하므로 CSS 변수를 0으로 강제 설정
    const isAndroid = Lib.getUserAgent() === "android";
    
    if (isAndroid) {
      document.documentElement.style.setProperty("--safe-area-inset-top", "0px");
      document.documentElement.style.setProperty("--safe-area-inset-right", "0px");
      document.documentElement.style.setProperty("--safe-area-inset-bottom", "0px");
      document.documentElement.style.setProperty("--safe-area-inset-left", "0px");
      setSafeAreaInsets({
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
      });
      return;
    }
    
    const style = window.getComputedStyle(document.documentElement);
    const top = Number(
      style.getPropertyValue("--safe-area-inset-top").replace(/\D/g, "")
    );
    const bottom = Number(
      style.getPropertyValue("--safe-area-inset-bottom").replace(/\D/g, "")
    );
    const left = Number(
      style.getPropertyValue("--safe-area-inset-left").replace(/\D/g, "")
    );
    const right = Number(
      style.getPropertyValue("--safe-area-inset-right").replace(/\D/g, "")
    );
    console.log("safe-area-insets", { top, right, bottom, left });
    setSafeAreaInsets({
      top:top,
      right:right,
      bottom:bottom,
      left:left,
    });
  };
  //#endregion


  //#region Globals

  // 세션 연장하기
  Global.refrechSession = () => {
    if (!Auth.isLogin) return;
    // sendSessionCheck(() => {
    // 	console.log("%crefrechSession", " color: #888 ")
    // })
  };

  // (아이폰 전용) 앱 상단, 하단 색상 바꾸기
  Global.setAppBg = (topColor, bottomColor, set = true) => {
    if (typeof topColor === "undefined") {
      topColor = Global.app.topColor;
      bottomColor = Global.app.bottomColor;
    } else if (typeof bottomColor === "undefined") bottomColor = topColor;
    if (set) {
      Global.app.topColor = topColor;
      Global.app.bottomColor = bottomColor;
    }
    // console.log({ topColor, bottomColor })
    Native.execute("AppManager", "backgroundColor", undefined, {
      top: topColor,
      bottom: bottomColor,
    });
  };

  // nav 바 보이기/가리기
  Global.setShowNav = (t) => {
    setShowNav(t);
    if (t) {
      App.current.classList.add("main--nav");
    } else {
      App.current.classList.remove("main--nav");
    }
  };

  Global.setShowHeader = (t) => {
    setShowHeader(t);
    if (t) {
      App.current.classList.add("main--header");
    } else {
      App.current.classList.remove("main--header");
    }
  };

  // header 세팅
  Global.setHeader = ({ show, type, className, title, left, right }) => {
    if (type && !className) className = type;
    setHeaderRight(right);
    setHeaderLeft(left);
    setHeaderClass(className);
    Global.setShowHeader(show);
    if (Lib.isNotNull(title)) setTitle(title);
  };


  const [prevMsg, setPrevMsg] = useState("");
  // alert
  Global.showAlert = (msg, alert) => {
    if (typeof msg === "object") {
      alert = msg;
    } else {
      alert = alert ?? {};
      alert.msg = msg;
      if (typeof alert === "function") alert.onOk = alert;
    }
    alert.id = alert.id ?? uuid();
    setAlerts((alerts) => [...alerts, alert]);

    // TODO 중복으로 겹쳐 띄워지는 알럿 처리 필요
    // if(msg != prevMsg){
    //   setAlerts((alerts) => [...alerts, alert]);
    //   setPrevMsg(msg)
    // }
  };

  Global.confirm = (msg, alert) => {
    if (typeof alert === "function") {
      alert = {
        msg: msg,
        onOk: alert,
      };
    } else if (typeof msg === "object") {
      alert = msg;
    } else if (typeof msg === "string") {
      alert.msg = msg;
    }
    Global.showAlert({
      ...alert,
      confirm: true,
    });
  };

  Global.hideAlert = (id) => {
    setAlerts((alerts) => alerts.filter((alert) => alert.id !== id));
  };

  Global.setMainClass = (className) => {
    Global.setMain({ className: className });
  };

  Global.setMain = (obj) => {
    if (obj.className) {
      main.current.setAttribute("class", obj.className);
    } else {
      main.current.removeAttribute("class");
    }

    if (obj.style) {
      let style;
      if (typeof obj.style === "object") {
        style = "";
        Object.keys(obj.style).forEach((key) => {
          style += `${Lib.camelToHypen(key)}: ${obj.style[key]};`;
        });
      } else {
        style = obj.style;
      }
      main.current.setAttribute("style", style);
    }
  };

  Global.setGoBack = (fn) => {
    Global.goBack = fn;
  };

  Global.goBack = () => {
    navigate(-1);
    /* const modal = document.querySelector("#modal")
        if (!modal.childElementCount) {
            navigate(-1)
        } else {
            console.log(modal.childElementCount)
        } */
  };

  Global.toast = (text) => {
    setToastText(text);
    setShowToast(true);
  };

  Global.deviceInfo = (callback) => {
    if (!(Global.device ? true : false)) {
      // WEB 테스트용
      // if (!(Global.test ? true : false)) {
      Native.execute("AppManager", "deviceInfo", (result) => {
        const info = JSON.parse(result);
        if (info.resultCode === "0") {
          Global.device = {
            appVersion: info.result["app-version"],
            model: info.result.model,
            os: info.result.os,
            osVersion: info.result["os-version"],
            pushToken: info.result.token,
          };

          if (callback) {
            callback(Global.device);
          }
        }
      });
    } else {
      // WEB 테스트용
      // Global.device = {
      //   appVersion: "1.0.0",
      //   model: "iPhone14,2",
      //   os: "iOS",
      //   osVersion: "15.3.1",
      // };

      if (callback) {
        callback(Global.device);
      }
    }
  };

  Global.setHeaderLeft = setHeaderLeft;
  Global.setHeaderRight = setHeaderRight;
  Global.navigate = navigate;
  Global.setLoading = setShowLoading; // toggle, true / false
  Global.showLoading = () => setShowLoading(true);
  Global.hideLoading = () => setShowLoading(false);
  Global.setTitle = setTitle;
  Global.user = user;
  Global.isLogin = isLogin;
  Global.didRun = didRun;
  Global.setDidRun = setDidRun;
  Global.setShield = setShield; // shield 활성/비활성 (화면상의 모든 버튼 안눌리게 막는 기능)
  Global.alert = Global.showAlert;
  Global.pushNav = Global.pushNav;
  Global.logout = logout;
  Global.appClose = appClose;
  if (typeof Global.onBackPress === "undefined") {
    Global.onBackPress = onBackPress;
  }
  window.dataCertificate = dataCertificate;
  window.onWakeApp = onWakeApp;
  window.onForegroundApp = onForegroundApp;
  window.onBackgroundApp = onBackgroundApp;
  window.goIndCertResult = goIndCertResult;
  window.showIndCertError = showIndCertError;
  window.goThinkPayCallback = goThinkPayCallback;
  window.goDataLink = goDataLink;
  window.appCall = appCall;
  window.onRecvPush = onRecvPush;
  window.onBackPress = onBackPress;

  const handleScroll = () => {
    const scrollPosition =
      Core.current && Core.current.scrollTop ? Core.current.scrollTop : 0;
    if (
      ["/", "/home", "/mydata", "/recommend"].includes(window.location.pathname) ||
      window.location.pathname.includes("/mcScore") ||
      window.location.pathname.indexOf("/recommend/grant") > -1
    ) {
      setScrollY(scrollPosition);
    }
  };

  useEffect(() => {
    console.log("%cApp", " color: red; font-weight: 600");
    // DB 이중화 서버 점검 공지 popup state default false init
    setPopup(false);

    // 세션 타이머 시작
    Global.refrechSession();

    setTimeout(getSafeAreaInsets, 500);

    Global.Webview = window.WEBVIEW;
    setSystem((prev) => ({
      ...prev,
      webview: window.WEBVIEW,
    }));

    // 스크롤 Y 값에 따른 Header Class
    window.addEventListener("scroll", handleScroll, true);

    console.log(sncnApis);
    // else {
    //     window.removeEventListener('scroll', handleScroll);
    // }

    // return () => {
    //     window.removeEventListener('scroll', handleScroll);
    // }슽
    // 스크롤 Y 값에 따른 Header Class
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  //#endregion
  // DB 이중화 서버 점검 공지의 useEffect로 인해 순차적 실행을 위해 위치 수정
  //#region Effects
  useEffect(() => {
    console.log('앱 open', location)
    Native.execute(
      "Analytics",
      "screenView",
      (result) => {
        console.log("screenView result = " + result);
      },
      {
        screenName: location.pathname,
        screenClass: location.pathname + " Class",
      }
    );
    // DB 이중화 서버 점검 공지 
    if (!popup) {
      const today = new Date();
      const bgnDate = new Date('2024-03-26 10:00:00');
      const endDate = new Date('2024-03-26 12:00:00');
      if (today.getTime() >= bgnDate.getTime() && endDate.getTime() >= today.getTime()) {
        setPopup(true);
        // DB이중화로 인한 서비스 이용제한 팝업
        Global.showAlert({
          msg: "서버 작업으로 인한 서비스 일시중단 안내<br/>24년 3월 26일 10:00 ~ 12:00",
          ok: "확인",
          confirm: false,
          onOk: () => Lib.nativeCall("AppManager", "appClose"),
        });
      }
    }

    Lib.scrollTo();

    Global.refrechSession();
    console.log(
      `%c${location.pathname} ???`,
      "color: brown; font-weight: bold"
    );

    Global.goBack = () => {
      navigate(-1);
      // const modal = document.querySelector("#modal")
      // if (!modal.childElementCount) {
      // 	navigate(-1)
      // } else {
      // 	console.log(modal.childElementCount)
      // }
    };

    console.log(`%c${location.pathname}`, "color: brown; font-weight: bold");

    const isLanding = /moneey-landing/.test(location.pathname);
    if (isLanding) {
      setDidRun(true); // 렌딩 페이지 접근시 라우터 사용 허용. Router.js 에서 사용조건이 didRun=true
    }

    if (isLogin) sendSessionCheck();

    document.querySelector(".App").style.transform = "";

    setShowLoading(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);
  //#endregion

  return (
    <AppContext.Provider value={Global}>
      <AuthContext.Provider
        value={{ user, login, logout, isLogin, setUser, setIsLogin }}
      >
        <div className="App" ref={App}>
          <div className="forBg" />
          <div className="core" ref={Core}>
            <main ref={main}>
              <Router didRun={didRun} />
            </main>
            <Header
              show={showHeader}
              title={title}
              className={
                scrollY !== 0 &&
                  (
                    ["/", "/home", "/mydata", "/recommend"].includes(window.location.pathname) ||
                    window.location.pathname.includes("/mcScore") ||
                    window.location.pathname.indexOf("/recommend/grant") > -1)
                  ? headerClass + " header-shadow"
                  : headerClass + " header-renewal"
              }
              left={headerLeft}
              right={headerRight}
            />
            <Nav show={showNav} />
            {shield && <div className="shield" />}
            <Alert alerts={alerts} />
            <Toast show={showToast} setShow={setShowToast} text={toastText} />
            <Loading show={showLoading} />
            <DataBottomResult show={checkMyDataLink} />
            <MyDataPreventLayer show={myDataLinkBottomLayer} closeLayer={()=>setMyDataLinkBottomLayer(false)} />
          </div>
        </div>
      </AuthContext.Provider>
    </AppContext.Provider>
  );
};

const MyDataPreventLayer = ({ show, closeLayer }) => {
  return (
    <LayerBottom show={show} closeLayer={closeLayer}>
      <div className="layer-text mt_30">
        고객님의 소중한 마이데이터 목록을 불러오고 있어요.<br />
        연동이 완료되면 이용 가능해요.
      </div>
      <div className='btn-group--inline btn-group  mt_20'>
          <Button className="btn btn--md " onClick={closeLayer}>확인</Button>
      </div>
    </LayerBottom>
  )
}

const DataBottomResult = ({ show }) => {
  const navigate = useNavigate()
  const setCheckMyDataLink = useSetRecoilState(checkMyDataLinkState)
  const [myDataLinkResultUrl, setMyDataLinkResultUrl] = useRecoilState(myDataLinkResultUrlState)
  const closeLayer = (isStay = true) =>{
    setCheckMyDataLink(undefined)
    const url = myDataLinkResultUrl
    setMyDataLinkResultUrl(undefined) // 초기화
    if(!isStay && url){
      navigate(url)
    }
  }
  return (
    <LayerBottom  
        show={show} 
        closeLayer={()=>closeLayer(true)}
      >
        <div className="layer-text mt_30">
          마이데이터 연동이 완료되었어요.<br />
          지금 확인해보세요!
        </div>
        <div className='btn-group--inline btn-group  flex-shrink_0 mt_20'>
            <Button className="btn btn--md btn--gray " onClick={()=>closeLayer(true)}>나중에 볼게요<br></br>(머무르기)</Button>
            <Button className="btn btn--md ml_10" onClick={()=>closeLayer(false)}>네, 지금볼게요<br></br>(이동하기)</Button>
        </div>
        
      </LayerBottom>
  )
}

export { AppContext, AuthContext };
export default App;
